angular.module('main').directive('btnSend', () => ({
	restrict: 'AE',
	scope: {
		text: '@snText'
	},
	template:
		'<button class="btn btn-default"><i class="fi fi-send"></i>{{text}}</button>',
	replace: true,
	transclude: true,
	link(scope) {
		scope.text = scope.text || 'Send';
	}
}));



// WEBPACK FOOTER //
// ./web/js/components/Buttons/btnSend.js